/* eslint-disable react/prop-types */
import { useState, useEffect, useContext } from 'react';
// import { useQuery } from 'react-query';
import {
  Container,
  Box,
  // useDisclosure,
} from '@chakra-ui/react';
import { AppContext } from './AppContext.jsx';
import { useForm } from 'react-hook-form';

// graphql components
import { searchDjtsByDivision } from './graphqlCompnents/DJT/searchDjtsByDivision.jsx';
import { getStatusIdByStatusCode } from './graphqlCompnents/DJT/getStatusIdByStatusCode.jsx';
import { fetchAllDivisions } from './graphqlCompnents/Billing/fetchAllDivisions.jsx';

// // generic functions
import { isValidDate } from './functions/dateTime.jsx';
import { formatDateFn } from './functions/dateTime.jsx';
import { isNumber } from './functions/number.jsx';

// components
import { SearchDailyJobTicketsByClientByDate } from './DailyJobTicket/SearchDailyJobTicketsByClientByDate.jsx';
import { ResultsTableEstimatesByClientByDate } from './DailyJobTicket/ResultsTableEstimatesByClientByDate.jsx';

// PDF
import { generatePdf } from './PDF/GeneratePDF.jsx';

// design components
import { ModuleBox } from './Structural/ModuleBox.jsx';
import { FormSelectSimple } from './Form/Select/FormSelectSimple.jsx';

import { PropTypes } from 'prop-types';

const TableRowHeight = 40; // Assuming each table row is 50px high
const TableHeaderHeight = 410;

export const Estimator = () => {

  const { store } = useContext(AppContext);
  const currentUserId = store?.userData?.id
  const supervisorMultiDivisions = store?.userData?.multiDivisions || [];
  const currentUserIsGlobalAdmin = store?.userData?.isGlobalAdmin||false
  // Home division (every team member has a divisionId). Combined with
  // multiDivisions (deduped) to populate the Select Job Ticket Division dropdown.
  const homeDivisionId = store?.userData?.divisionId
  const doShowAllSupervisorsSwitch = store?.enableAllSupervisors
  const showDownloadPDFButton = store?.showDownloadPDF||false
  const [ clientSelected, setClientSelected ] = useState(null)
  const [ clientIdSelected, setClientIdSelected ] = useState('')
  const [ djtStartDate, setDjtStartDate ] = useState('')
  const [ djtEndDate, setDjtEndDate ] = useState('')
  const [ endDateDisabled, setEndDateDisabled ] = useState(true)
  const [ showAllResults, setShowAllResults ] = useState(false)
  const [ djtSearchResultsNextToken, setDjtSearchResultsNextToken ] = useState(null)
  const [ loadMoreDisabled, setLoadMoreDisabled ] = useState(false)
  // all of the djts get merged into this array
  let filteredDjts = []
  // the final object to store this filtered array
  const [ sortedFilteredDjts, setSortedFilteredDjts ] = useState([])
  const [currentDivisionId, setCurrentDivisionId] = useState(null);
  useEffect(() => {
    // Only seed the starting division from the home divisionId for users who
    // will NOT get a dropdown-driven default (single-division supervisors).
    // Admins and multi-division supervisors get their starting division from the
    // default-division effect once divisions load; seeding home here too would
    // fire an extra initial search against home first (the "flash").
    const willUseDropdownDefault = currentUserIsGlobalAdmin || supervisorMultiDivisions?.length > 0;
    if (!willUseDropdownDefault && store?.userData?.divisionId) {
      setCurrentDivisionId(store.userData.divisionId);
    }
  }, [store?.userData?.divisionId, currentUserIsGlobalAdmin, supervisorMultiDivisions?.length]);
  
  const { control, register, setValue, formState: { errors } } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {}
  });

  const [ divisions, setDivisions ] = useState([])
  const [ selectedDivision, setSelectedDivision ] = useState(null)
  useEffect(() => {
    // The spell to summon all divisions from the ether
    const loadDivisions = async () => {
      try {
        const divisions = await fetchAllDivisions();
        console.warn('----- divisions: ', divisions);
        setDivisions(divisions);
      } catch (error) {
        // In case the spell fizzles, you know why
        console.error('Failed to fetch divisions:', error);
      }
    };
  
    // And... poof! Let the magic happen.
    loadDivisions();
  }, []); // The empty array makes sure this happens once, right after the initial curtain lift
  
  const handleDivisionChanged = (option) => {
    setSelectedDivision(option)
    setCurrentDivisionId(option?.value)
    // Clear any client selected under the previous division — it won't exist in
    // the newly selected division's client list, and would otherwise keep the
    // search filtered to a cross-division client. Skipped on initial default
    // (no client selected yet).
    if (clientSelected) {
      setClientIdSelected(null);
      setClientSelected(null);
      onCustomerChanged(null, {action: "clear", removedValues: [clientSelected], name: "selectCustomer"});
    }
  }

  useEffect(() => {
    if (divisions.length > 0 && (currentUserIsGlobalAdmin || supervisorMultiDivisions?.length > 0)) {
      const available = filteredDivisions(currentUserIsGlobalAdmin, supervisorMultiDivisions, divisions, homeDivisionId);
      // Default to the user's home division (their divisionId) for everyone,
      // admins included. Falls back to the first available division only if the
      // home id isn't present (shouldn't normally happen: admins see all
      // divisions; supervisors always include home via the union). Avoids the
      // old admin behavior of available[0], which was just whatever order the
      // divisions fetch happened to return.
      const defaultDivision = available.find(d => d.id === homeDivisionId) || available[0];
      if (defaultDivision) {
        setSelectedDivision({ label: defaultDivision.defaultQBClass, value: defaultDivision.id });
        handleDivisionChanged({ label: defaultDivision.defaultQBClass, value: defaultDivision.id });
        setCurrentDivisionId(defaultDivision.id);
      }
    }
  },[divisions, currentUserIsGlobalAdmin, supervisorMultiDivisions?.length, homeDivisionId])

  const [numberOfRows, setNumberOfRows] = useState(0);

  const updateTableRows = () => {
    const screenHeight = window.innerHeight;
    // Calculate the number of rows that can fit, subtract header height from screen height before division
    let rowsThatCanFit = Math.floor((screenHeight - TableHeaderHeight) / TableRowHeight);
    if (rowsThatCanFit > 8) {
        rowsThatCanFit = 75;
    }
    setNumberOfRows(rowsThatCanFit);
};

  useEffect(() => {
      updateTableRows();
      window.addEventListener('resize', updateTableRows);
      return () => window.removeEventListener('resize', updateTableRows);
  }, []);

    //numberOfRows
  useEffect(() => {
    (numberOfRows>0) && console.info('numberOfRows: ', numberOfRows)
  },[numberOfRows])
  // const searchLimit = 11
  const searchLimit = numberOfRows

  const onCustomerChanged = async (event) => {
    // console.log('event: ', event)
    setLoadMoreDisabled(false)
    if (event===null) {
      // console.log('EVENT IS NULL')
      setClientSelected(null)
      setClientIdSelected(null)
      searchDjts(
        {
          djtStatusId: searchStatusTypeId, 
          divisionId: currentDivisionId,
          multiDivisions: supervisorMultiDivisions,
          djtClientId: '', 
          djtDate: djtStartDate, 
          djtEndDate: djtEndDate, 
          limit: searchLimit, 
          nextToken: null 
        }, showAllResults, true)
        .catch(console.error);
    } else {
      setClientSelected({label: event.label, value: event.value})
      setClientIdSelected(event.value)
      // now search djts for customer
      searchDjts(
        {
          djtStatusId: searchStatusTypeId, 
          divisionId: currentDivisionId,
          multiDivisions: supervisorMultiDivisions,
          djtClientId: event.value, 
          djtDate: djtStartDate, 
          djtEndDate: djtEndDate, 
          limit: searchLimit, 
          nextToken: null 
        }, showAllResults, true)
        .catch(console.error);
    }
  }

  const onStartDateChanged = async (date) => {
    setLoadMoreDisabled(false)
    if (date===null) {
      setEndDateDisabled(true)
      setDjtStartDate(null)
      searchDjts(
        {
          djtStatusId: searchStatusTypeId, 
          divisionId: currentDivisionId,
          multiDivisions: supervisorMultiDivisions,
          djtClientId: clientIdSelected, 
          djtDate: '', 
          djtEndDate: '', 
          limit: searchLimit, 
          nextToken: null 
        }, showAllResults, true)
        .catch(console.error);
    } else {
      const startDate = date
      if (isValidDate(date)) {
        setEndDateDisabled(false)
        setDjtStartDate(startDate)
        searchDjts(
          {
            djtStatusId: searchStatusTypeId, 
            divisionId: currentDivisionId,
            multiDivisions: supervisorMultiDivisions,
            djtClientId: clientIdSelected, 
            djtDate: startDate, 
            djtEndDate: djtEndDate, 
            limit: searchLimit, 
            nextToken: null 
          }, showAllResults, true)
          .catch(console.error);
      }
    }
  }

  const onEndDateChanged = async (date) => {
    setLoadMoreDisabled(false)
    if (date===null) {
      setDjtEndDate(null)
      searchDjts(
        {
          djtStatusId: searchStatusTypeId, 
          divisionId: currentDivisionId,
          multiDivisions: supervisorMultiDivisions,
          djtClientId: clientIdSelected, 
          djtDate: djtStartDate, 
          djtEndDate: '', 
          limit: searchLimit, 
          nextToken: null 
        }, showAllResults, true)
        .catch(console.error);
    } else {
      const endDate = date
      if (isValidDate(endDate)) {
        setEndDateDisabled(false)
        setDjtEndDate(endDate)
        searchDjts(
          {
            djtStatusId: searchStatusTypeId, 
            divisionId: currentDivisionId,
            multiDivisions: supervisorMultiDivisions,
            djtClientId: clientIdSelected, 
            djtDate: djtStartDate, 
            djtEndDate: endDate, 
            limit: searchLimit, 
            nextToken: null 
          }, showAllResults, true)
          .catch(console.error);
      }
    }
  }

  const [ createdAsEstimateStatusId, setCreatedAsEstimateStatusId ] = useState(null)  // created as estimate
  let approvalRequiredStatusId = null;
  const [ deletedStatusId, setDeletedStatusId ] = useState(null)                      // deleted
  const [ archivedStatusId, setArchivedStatusId ] = useState(null)                    // archived
  const [ showSearchResutlsTable, setShowSearchResutlsTable ] = useState(true)
  const [ searchStatusTypeId, setSearchStatusTypeId] = useState(null)

  useEffect(() => {
    const fetchStatusIds = async () => {
      if (!createdAsEstimateStatusId) {
        const createdAsEstimateId = await getStatusIdByStatusCode('created-as-estimate')  // estimates
        setCreatedAsEstimateStatusId(createdAsEstimateId)
      }
    }
    fetchStatusIds()
  },[createdAsEstimateStatusId])

  useEffect(() => {
    const fetchStatusIds = async () => {
      if (!archivedStatusId) {
        const archivedId = await getStatusIdByStatusCode('archived-estimate')  // archived-estimate
        setArchivedStatusId(archivedId)
      }
    }
    fetchStatusIds()
  },[archivedStatusId])

  useEffect(() => {
    const fetchStatusIds = async () => {
      if (!deletedStatusId) {
        const deletedId = await getStatusIdByStatusCode('deleted-estimate')      // deleted-estimate
        setDeletedStatusId(deletedId)
      }
    }
    fetchStatusIds()
  },[deletedStatusId])

  // should be initial load only - set to saved submissions
  useEffect(() => {
    (!searchStatusTypeId && createdAsEstimateStatusId) && setSearchStatusTypeId(createdAsEstimateStatusId)
  },[searchStatusTypeId, createdAsEstimateStatusId])

  // useEffect(() => {
  //   (!searchStatusTypeId && pendingSubmissionStatusId) && setSearchStatusTypeId(pendingSubmissionStatusId)
  // },[searchStatusTypeId, pendingSubmissionStatusId])

  const searchStatusId = [
    createdAsEstimateStatusId,  // 'created-as-estimate', 153a7d46-b025-486e-8417-eca2af57d8bb
    archivedStatusId,           // 'archived-estimate', 6a9af4ee-a185-4f3d-a810-eb5d2f9843d8
    deletedStatusId,            // 'deleted', 15b03dbc-14bb-47fa-a240-44d0992afb2b
    // pendingSubmissionStatusId,  // 'queued-pending-submission', 7fd6f20e-9698-4646-ac68-beebab1d0d5b
    // pendingApprovalStatusId,    // 'queued-pending-approval', 2a279c1e-110c-4223-a2bd-e411fc51f89e
    // approvalRequiredStatusId,   // 'queued-unapproved-with-issue', 468eb65a-8471-47e9-98cb-3258570f71fa
  ]

  let isReviewing = false
  const [ currentSelectedTab, setCurrentSelectedTab ] = useState(0)
  const handleTabChange = async (tab) => {
    setShowSearchResutlsTable(false)
    const status = searchStatusId[tab]
    setCurrentSelectedTab(tab)
    setSearchStatusTypeId(status)
    const searchProps = {
      djtStatusId: status,
      divisionId: currentDivisionId,
      multiDivisions: supervisorMultiDivisions,
      djtClientId: clientIdSelected, 
      djtDate: djtStartDate, 
      djtEndDate: djtEndDate, 
      limit: searchLimit, 
      nextToken: null,
    }
    await searchDjts(searchProps, showAllResults, true)
    setShowSearchResutlsTable(true)
  }

  const [ approvalRequiredCount, setApprovalRequiredCount ] = useState(0)
  const [ djtSearchProps, setDjtSearchProps ] = useState(null)
  const searchDjts = async (props, optShowAll, optClearAll) => {
    console.log('props: ', props)
    filteredDjts = [];
    
    let searchProps = null
    if (!props) {
      searchProps = {
        djtStatusId: searchStatusTypeId,
        divisionId: currentDivisionId,
        multiDivisions: supervisorMultiDivisions,
        djtClientId: clientIdSelected, 
        djtDate: djtStartDate, 
        djtEndDate: djtEndDate, 
        limit: searchLimit, 
        nextToken: null,
      }
      optClearAll=true
    } else {
      searchProps = props
    }

    // default to show only super djts
    let doShowAllResults = false
    if (optShowAll===true) {
      doShowAllResults = true
    }
    if (optShowAll===false) {
      doShowAllResults = false
    }
    if (optShowAll===undefined) {
      doShowAllResults = showAllResults
    }

    // New visibility model: DailyJobTicket/Estimator are supervisor/admin-only,
    // and the division dropdown already restricts selection to divisions the user
    // has access to (home divisionId + multiDivisions). Within any such division a
    // supervisor sees every estimate regardless of who created it, so the search is
    // never scoped to a single team member here.
    searchProps.teamMemberId = null

    setDjtSearchProps(searchProps)
    setShowAllResults(doShowAllResults)

    // we shouldn't run this every time.
    const approvalRequiredPending = await searchDjtsByDivision({
      djtStatusId: approvalRequiredStatusId,
      divisionId: currentDivisionId,
      multiDivisions: supervisorMultiDivisions,
      djtClientId: "", 
      teamMemberId: null,
      djtDate: "", 
      djtEndDate: "", 
      limit: searchLimit, 
      nextToken: null,
    })

    const approvalRequiredPendingCount = approvalRequiredPending?.items?.length
    if (isNumber(approvalRequiredPendingCount)) {
      setApprovalRequiredCount(approvalRequiredPendingCount)
    }
    
    // we need to merge the existing array in with the search results unless this is a new search
    let allDjtData = []
    const allNewDjtData = await searchDjtsByDivision(searchProps)||[];
    console.log('allNewDjtData: ', allNewDjtData)
    // serchProps.djtStatusId = approvalRequiredStatusId
    // this doesn't even get called until we click the tab. Need to call this sooner.
    // if (allNewDjtData.data.items.length>0 && isReviewing===true) setApprovalRequiredCount(allNewDjtData.data.items.length)
    // we need to run the approval required query to get the count before the first tab is loaded
    // console.log('SEARCH PROPS: ', searchProps)
    // console.log(' >>>>> DATA FROM SEARCH: ', allNewDjtData)
    
    const allNewDjtDataNextToken = allNewDjtData?.nextToken

    // if clearAll, then wipe previous data
    if (optClearAll===true || allNewDjtData?.items.length===0) {
      console.log('clearing all')
      allDjtData = allNewDjtData?.items
      allDjtData.nextToken = allNewDjtDataNextToken
      setSortedFilteredDjts(null)
    } else {
      console.log('not clearing all')
      if (sortedFilteredDjts!==undefined && sortedFilteredDjts!==null && sortedFilteredDjts?.length>0) {
        // clear out the waitingForParent flag
        console.log('clearing')
        for (const djt of sortedFilteredDjts) {
          djt.waitingForParent = false
        }

        const mergedArray = sortedFilteredDjts.concat(allNewDjtData.items)
        allDjtData = mergedArray
        allDjtData.nextToken = allNewDjtDataNextToken
      } else {
        console.log('not clearing')
        allDjtData = allNewDjtData?.items
        allDjtData.nextToken = allNewDjtDataNextToken
      }
    }

    console.log('should be items for division:', allDjtData)

    // filter allDjtData for parents or childless
    // these are coming in as most recent first
    const djtDataParentOrChildless = allDjtData?.filter( 
      djt => djt?.isDuplicate===false 
    )

    // since we want to display these as newest first, we need to flip this array
    // so as we filter it, we end up with newest first
    djtDataParentOrChildless.sort((a, b) => a.djtDate - b.djtDate)

    // console.log('djtDataParentOrChildless: ', djtDataParentOrChildless)
    const djtChildren = allDjtData?.filter(
      djt => djt?.isDuplicate===true
    )
    
    // iterate through non-duplicates
    djtDataParentOrChildless?.forEach( djt => {
      const thisDjtId = djt.id

      // this is NOT a child/duplicate, it is a parent -  merge into the all allray
      filteredDjts.push(djt)

      // now check if it has any children - some of these children may not have parents loaded yet.
      const childrenOfThisParentUnsorted = djtChildren?.filter(e => e.parentId===thisDjtId)

      // now we need to reverse the sorting on these. parents get sorted from most recent forward
      // children get sorted from oldest to newest forward
      const childrenOfThisParent = childrenOfThisParentUnsorted?.sort((a, b) => a.djtDate > b.djtDate)

      if (childrenOfThisParent?.length>0) {
        // this current djt has kids
        childrenOfThisParent.forEach( child => {
          filteredDjts.push(child)
          const indexOfRemovedChild = djtChildren.findIndex(object => {
            return object.id === child.id
          })
          djtChildren.splice(indexOfRemovedChild, 1)
        })
      }
    })

    console.log(' ---- filteredDjts: ', filteredDjts)
    console.log(' ---- all djts: ', allDjtData)

    // for each of the orphaned children, re-insert them in the correct order
    djtChildren.forEach( djtChild => {
      // console.log(' >>>>> child nodes of parent djtNotes: ', djtChild.djtNotes)
      djtChild.waitingForParent = true

      // did we find somewhere to put it?
      let insertedDjt = false
      // if the orphaned child djtDate is <= filtered djt date && the 
      // filteredDjt is not a duplciate, insert
      for (const [djtIndex, filteredDjt] of filteredDjts.entries()) {
        
        if (djtChild.djtDate>=filteredDjt.djtDate && filteredDjt.isDuplicate!==true) {
          // console.log('THIS IS WHERE IT GETS INSERTED')
          filteredDjts.splice(djtIndex, 0, djtChild)
          insertedDjt = true
          break
        }
      }
      // if we made it here we have a straggler that didn't match any of the current
      if (insertedDjt===false) {
        const filteredDjtsInsertAt = filteredDjts.length+1
        filteredDjts.splice(filteredDjtsInsertAt, 0, djtChild)
      }
    })

    // console.log(' ---- filteredDjts: ', filteredDjts)
    // console.log(' ---- all djts: ', allDjtData)
    
    setLoadMoreDisabled(false)
    if (allDjtData?.nextToken===null || allDjtData?.length===0 || allDjtData?.length<searchLimit ) {
      setLoadMoreDisabled(true)
    }

    setDjtSearchResultsNextToken(allDjtData?.nextToken)
    let clearExistingResults = (optClearAll===true) ? true : false

    if (searchProps.nextToken!==null && clearExistingResults===false) {
      // setDjtSearchResults(searchResults => searchResults.concat(filteredDjts))

      // mergin up above before here
      // setSortedFilteredDjts(searchResults => searchResults.concat(filteredDjts))
      setSortedFilteredDjts(filteredDjts)
    } else {
      // setDjtSearchResults(filteredDjts)
      setSortedFilteredDjts(filteredDjts)
    }

    // check if everything loaded and return loaded status
    return(true)
  }

  // initial search, hard coded for recent submissions, show pending approvals
  useEffect(() => {
    if (currentDivisionId && createdAsEstimateStatusId) {
      console.log('should be seaarching for division: ', currentDivisionId)
      setValue('searchDate', null)
      setValue('endDate', null)
      setValue('selectCustomer', null)
      // setLoadMoreDisabled(false)
      setLoadMoreDisabled(true)
      searchDjts({djtStatusId: createdAsEstimateStatusId, divisionId: currentDivisionId, multiDivisions: supervisorMultiDivisions, djtClientId: '', djtDate: '', djtEndDate: '', limit: searchLimit, nextToken: null }, showAllResults)
        .catch(console.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDivisionId, createdAsEstimateStatusId])

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleLoadMore = () => {
    searchDjts({
      djtStatusId: searchStatusTypeId,
      divisionId: currentDivisionId,
      multiDivisions: supervisorMultiDivisions,
      djtClientId: clientIdSelected, 
      djtDate: djtStartDate, 
      djtEndDate: djtEndDate, 
      limit: searchLimit, 
      nextToken: djtSearchResultsNextToken 
    }, showAllResults).catch(console.error);
  }

  const handleShowAllToggle = async (showAll) => {
    // clear out the existing serach results
    // setSortedFilteredDjts(null)

    // console.log(' <<<<<< showAll in load more:', showAll)
    // toggle the data getting sent down to results
    setShowAllResults(showAll)
    // console.log('djtSearchProps before: ', djtSearchProps)
    djtSearchProps.nextToken = null
    setLoadMoreDisabled(true)
    // console.log('djtSearchProps after: ', djtSearchProps)
    searchDjts(djtSearchProps, showAll, true)
  }

  const filteredDivisions = (isGlobalAdmin, supervisorMultiDivisions, divisions, homeDivisionId) => {
    // If user is a global admin, return all divisions
    if (isGlobalAdmin) return divisions;

    // Everyone else: their home division + any multiDivisions, de-duplicated.
    // The Set collapses any overlap (e.g. a record that already lists its home
    // division inside multiDivisions). Filtering against the fetched divisions
    // means a stale/unknown id simply contributes nothing instead of erroring.
    const allowed = new Set(supervisorMultiDivisions || []);
    if (homeDivisionId) allowed.add(homeDivisionId);

    if (allowed.size > 0) {
      return divisions.filter(division => allowed.has(division.id));
    }

    // Otherwise, return an empty array (no access to divisions)
    return [];
  };

  const DivisionsDropdown = ({ isGlobalAdmin, multiDivisions, divisions, homeDivisionId }) => {
    const options = filteredDivisions(isGlobalAdmin, multiDivisions, divisions, homeDivisionId);
  
    return (
      <FormSelectSimple
        key='select_division'
        register={register}
        control={control}
        errors={errors}
        isRequired={true}
        rules={{ required: "A job ticket division is required" }}
        fieldname="selectDivision"
        fieldlabel="Select Job Ticket Division"
        placeholder={'Select job ticket division or start typing'}
        optionsArray={Array.isArray(options) ? options.map(({ defaultQBClass, id }) => ({
          label: defaultQBClass,
          value: id,
        })) : []}
        onChange={(e) => handleDivisionChanged(e)}
        selectedoption={selectedDivision}
      />
    );
  };

  DivisionsDropdown.propTypes = {
    isGlobalAdmin: PropTypes.bool.isRequired,
    multiDivisions: PropTypes.arrayOf(PropTypes.string).isRequired,
    divisions: PropTypes.arrayOf(PropTypes.object).isRequired,
    homeDivisionId: PropTypes.string,
  };

  return (

    <Container as="form">

      <SearchDailyJobTicketsByClientByDate 
        control={control}
        register={register}
        currentDivisionId={currentDivisionId}
        endDateDisabled={endDateDisabled}
        onChange={(event, action) => onCustomerChanged(event, action)}
        startDate={startDate}
        startDateOnChange={(date) => {
          setStartDate(date);
          onStartDateChanged(formatDateFn(date), "selected");
        }}
        endDate={endDate}
        endDateOnChange={(date) => {
          setEndDate(date);
          onEndDateChanged(formatDateFn(date), "selected");
        }}
        clientSelected={clientSelected}
        djtStartDate={djtStartDate}
        djtEndDate={djtEndDate}
        clientIconOnClick={() => {
          setClientIdSelected(null);
          setClientSelected(null);
          const action = {action: "clear", removedValues: [clientSelected], name: "selectCustomer"};
          onCustomerChanged(null, action);
        }}
        startDateIconOnClick={() => {
          setStartDate(new Date())
          setDjtStartDate(null);
          onStartDateChanged(null);
        }}
        endDateIconOnClick={() => {
          setEndDate(new Date())
          setDjtEndDate(null);
          onEndDateChanged(null);
        }}
      />

      {(currentUserIsGlobalAdmin || supervisorMultiDivisions?.length>0) && <ModuleBox>
        <Box w={'50%'}>
          <DivisionsDropdown 
            isGlobalAdmin={currentUserIsGlobalAdmin}
            multiDivisions={supervisorMultiDivisions}
            divisions={divisions}
            homeDivisionId={homeDivisionId}
          />
        </Box>
      </ModuleBox>}

      <ResultsTableEstimatesByClientByDate
        djtSearchResults={sortedFilteredDjts}
        loadMoreOnClick={() => handleLoadMore()}
        loadMoreDisabled={loadMoreDisabled}
        handleRefresh={searchDjts}
        handleShowAllToggle={handleShowAllToggle}
        currentUserId={currentUserId}
        currentDivisionId={currentDivisionId}
        handleTabChange={handleTabChange}
        showSearchResutlsTable={showSearchResutlsTable}
        isReviewing={isReviewing}
        approvalRequiredCount={approvalRequiredCount}
        doShowAllSupervisorsSwitch={doShowAllSupervisorsSwitch}
        showDownloadPDFButton={showDownloadPDFButton}
        // handleGeneratePdf={handleGeneratePdf}
        handleGeneratePdf={generatePdf}
        currentTab={currentSelectedTab}
        register={register}
        errors={errors}
      />

      <Box mt='50px'></Box>

    </Container>


  );
}